<template>
	<div class="full-height">
		<div class="login-main">
			<div style="position: absolute; top: 15px; right: 15px; z-index: 9" v-if="user.id">
				<a href="#" class="btn btn-light" @click.prevent="$auth.logout()">
					<i class="fas fa-sign-out-alt"></i>
				</a>
			</div>
			<div class="login-content">

				A SmartConnect<br>
				virtual demonstration platform.



			</div>
			<div class="login-btns container">
				<div v-if="!user.id" class="row justify-content-center">
					<div class="col-md-6 col-lg-4">
						<form class="login-form" @submit.prevent="login">
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-3 col-form-label text-left">Email</label>
								<div class="col-sm-9">
									<input type="text" v-model='email' class="form-control" id="staticEmail" value="" v-bind:class="{'is-invalid': loginError}">
								</div>
							</div>
							<div class="form-group row">
								<label for="inputPassword" class="col-sm-3  col-form-label text-left">Password</label>
								<div class="col-sm-9">
									<input type="password" v-model='password' class="form-control" id="inputPassword" placeholder="" :class="{'is-invalid': loginError}">
								</div>
							</div>
							<div class="form-group row">
								<div class="col-sm-2 offset-sm-3">
									<button type="submit" class="btn btn-secondary">
										<span v-if="loading" class="spinner-border spinner-border-sm float-right mt-1" role="status" aria-hidden="true"></span>
  										Login
									</button>
								</div>
							</div>

						</form>
					</div>
				</div>
				<div v-else >
					<button class="btn btn-dark mr-3 ml-3 " @click.prevent="view='load'"> <i class="app-icon archive"></i> Load Scenario</button>
					<button class="btn btn-secondary ml-3 mr-3" @click.prevent="view='location'"> <i class="app-icon forward"></i> Start New</button>

				</div>
			</div>

			<div class='text-white p-2 version'>
				Version: {{version}}
			</div>


		</div>
		<div class="login-footer">

		</div>
	</div>
</template>

<script>

	export default {
		name: 'Login',
		data() {
			return {
				email: '',
				password: '',
				loginError: false,
				loading: false
			}
		},
		watch: {
			email() {
				this.loginError = false;
			},
			password() {
				this.loginError = false;
			}
		},
    	computed: {
			logged: {
				get() { return this.$store.state.logged },
				set(value) { this.$store.commit('setState', ['logged', value])}
			},
			user: {
				get() { return this.$store.state.user },
				set(value) { this.$store.commit('setState', ['user', value])}
			},
			view: {
				get() { return this.$store.state.view },
				set(value) { this.$store.commit('setState', ['view', value])}
			},
			version() {
				return this.$config.version;
			}
		},
		methods: {
			login() {
				this.loading = true;
				this.$auth.post('/auth/login', { email: this.email, password: this.password })
				.then(request => {
					this.loading = false;
					var response = request.data;
					if (response.status == 'error') {
						this.loginError = true;
					}
					else {
						this.$auth.login(response.rec);
						this.user = this.$auth.getUser();

					}
				})
				.catch((request) => {

				})
			}
		},
		mounted() {
			this.user = this.$auth.getUser();
		}

	}
</script>
